import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-644f64bf")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-4" }, "Quick Actions", -1)
const _hoisted_4 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_5 = { class: "quick-plan-action-holder me-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "link-quick-action" }, "Register New Plan", -1)
const _hoisted_7 = {
  key: 1,
  class: "\n          text-decoration-none\n          border\n          rounded\n          p-3\n          d-flex\n          justify-content-between\n          align-items-center\n        ",
  target: "_blank",
  href: "https://akko.link/partner-platform-faq-info"
}
const _hoisted_8 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_9 = { class: "quick-plan-action-holder me-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "link-quick-action" }, "FAQs and Info", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegisterNewPlanIcon = _resolveComponent("RegisterNewPlanIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ContactSupportIcon = _resolveComponent("ContactSupportIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (
          _ctx.hasPartnerRegisterNewPlanViewTabPermission &&
          _ctx.hasPartnerPortalRegisterNewPlanViewTabPermission
        )
        ? (_openBlock(), _createBlock(_component_RouterLink, {
            key: 0,
            to: _ctx.RoutePath.HOME_REGISTER_NEW_PLAN,
            class: "\n          text-decoration-none\n          border\n          rounded\n          p-3\n          mb-3\n          d-flex\n          justify-content-between\n          align-items-center\n        "
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_RegisterNewPlanIcon, { class: "w-100 h-100" })
                ]),
                _hoisted_6
              ]),
              _createVNode(_component_ChevronRightIcon, {
                style: {"min-width":"1em"},
                class: "justify-self-end"
              })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      (
          _ctx.hasPartnerFaqsInfoViewTabPermission &&
          _ctx.hasPartnerPortalFaqsInfoViewTabPermission
        )
        ? (_openBlock(), _createElementBlock("a", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_ContactSupportIcon, { class: "w-100 h-100" })
              ]),
              _hoisted_10
            ]),
            _createVNode(_component_ChevronRightIcon, { style: {"min-width":"1em"} })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}